import { stringify } from 'qs';
export default function paramsSerializer(params) {
    return stringify(params, { arrayFormat: 'repeat' });
}
//# sourceMappingURL=paramSerializer.js.map